import { render, staticRenderFns } from "./NavigationAddCoursesButtons.vue?vue&type=template&id=bd4d6e14&scoped=true&"
import script from "./NavigationAddCoursesButtons.vue?vue&type=script&lang=js&"
export * from "./NavigationAddCoursesButtons.vue?vue&type=script&lang=js&"
import style0 from "./NavigationAddCoursesButtons.vue?vue&type=style&index=0&id=bd4d6e14&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd4d6e14",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VContainer,VIcon})
